import React from 'react';
import { useResendEmailMutation } from 'generated/graphql';
import { AppEventSelectField } from 'modules/layer01/selectFields';


export function useResendEmail({
  id/*, appEvent*/
}: {
  id: string;
}) {
  const [fnMutate, tuple] = useResendEmailMutation({
    refetchQueries: [
      // TODO: implement this
      // {
      //   query: SendGridEmailLogWidgetDocument,
      //   variables: {
      //     options: {
      //       filter: {
      //         orderId: id || null
      //         // returnAuthorizationId: id || null
      //       }
      //     }
      //   }
      // }
    ]
  });



  const fnWrappedMutate = React.useCallback(async (formState: { appEvent: AppEventSelectField.IAppEvent; }) => {
    await fnMutate({
      variables: {
        input: {
          id,
          appEvent: formState.appEvent.name
        }
      }
    });
  }, [
    fnMutate,
    id
  ]);



  return [
    fnWrappedMutate,
    {
      ...tuple,
      data: null
    }
  ] as const;
}
